import React, {useEffect, useState} from 'react';
import {get, post} from '../../../Model/Network/Config/Axios'
import { resolveActionOrigin } from '../../../Model/Network/Api/config'
import Tick from '../tick.png'
import Ques from '../question.png'
import Eror from '../error.png'
import { Spinner } from '../../Common/fLoader';
import {useLocation} from 'react-router-dom'
import { Details } from './Details';
import { Dialog } from '../../Common/Dialog';

function Index(props) {

    let LOCATION = useLocation()
    const PARAMS = new URLSearchParams(LOCATION.search);
    const Token = PARAMS.get('token');
    
    //Decoding Token for origin
    let json = {};
    if (Token) {
        var base64Url = Token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        json = JSON.parse(jsonPayload);
    }
    let Origin = resolveActionOrigin(LOCATION.search, json);
    const [response,setResponse] = useState({})
    const [btnLoading,setLoading] = useState(false)
    const [Modal,setModal] = useState(false)

    useEffect(()=>{
		navigator.serviceWorker.getRegistrations().then((registrations) => {
			registrations.forEach((registration) => {
				registration.unregister();
			});
		});
		caches.keys().then((keyList) => {
			console.log(keyList);
			return Promise.all(
			  keyList.map((key) => {
				return caches.delete(key);
			  })
			);
		  });
	},[])

    const [Status, setStatus] = useState(undefined);
    
    useEffect(() => {
        fetch(Token)
    }, [Token]);

    const fetch = (token) => {
        if(!token){
            setStatus('Invalid')
            return
        }else{
            getDetails(token)
        }
    }

    const approveAction = (token) => {
        setLoading(true)
        post(`${Origin}employee/others/action`, { token, confirm: 'yes' }, (e, r) => {
            if (e) {
                setStatus('Error')
            } else if(r) {
                setStatus('Success')
            }
            setLoading(false)
            setModal(undefined)
        })
    }

    const declineAction = (token) => {
        setLoading(true)
        post(`${Origin}employee/others/action`, { token, confirm: 'no' }, (e, r) => {
            if (e) {
                setStatus('Error')
            } else if(r) {
                setStatus('Success')
            }
            setLoading(false)
            setModal(undefined)
        })
    }

    const getDetails = (token) => {
        get(`${Origin}employee/others/action/approval`, (e, r) => {
            if (r) {
                setResponse(r)
                setStatus('Valid')
            }
        }, { token })
    }

return (<>
    <div className='mt-5 mb-5'>
       {
            Status==='Success'?
            <>
            <div className="container cards" style={{fontSize: '14px', borderRadius: '10px', textAlign: 'center'}}>
                <img className="img-fluid mb-4 m-auto" src={Tick} style={{maxWidth: '80px'}} alt=""/>
                <h1 className="display-6 fw-bold">
                    Success
                </h1>
                <p>
                    Action completed successfully
                </p>
            </div>
            </>
            :Status==='Error'?
            <>
            <div className="container cards" style={{fontSize: '14px', borderRadius: '10px', textAlign: 'center'}}>
                <img className="img-fluid mb-4 m-auto" src={Eror} style={{maxWidth: '80px'}} alt=""/>
                <h1 className="display-6 fw-bold">
                    Oops !
                </h1>
                <p>Error occured, your request was not completed</p>
                <button onClick={()=>approveAction(Token)} className="btn btn-success mt-2" type="button" style={{height: '50px'}}>Retry</button>
            </div>
            </>
            :Status==='Invalid'?
            <div className="container cards" style={{fontSize: '14px', borderRadius: '10px', textAlign: 'center'}}>
                <img className="img-fluid mb-4 m-auto" src={Ques} style={{maxWidth: '80px'}} alt=""/>
                <h1 className="display-4 fw-bold">No Token</h1>
                <p>Your action does not have a valid request token</p>
            </div>
            :Status==='Valid'?
            <Details loading={btnLoading}  response={response} onDecline={()=> setModal('Decline')} onRevert={()=> setModal('Revert')} onApprove={()=> setModal('Approve') }  />
            // <div className="container cards" style={{fontSize: '14px', borderRadius: '10px', textAlign: 'center'}}>
            //     <h1 className="display-6 fw-bold">Approve</h1>
            //     <p>Are you sure you want to approve this action</p>
            //     <button onClick={()=>approveAction(Token)} className="btn btn-success mt-3" type="button" style={{height: '50px'}}>Yes, Approve</button>
            // </div>
            :<Spinner style={{marginTop: '150px'}}/>
       }
           <Dialog open={Modal} onClose={() => setModal(undefined)}>
                    <div className="row">
                        <div className="p-2 col-md-12 position-relative">
                            <div>
                                {!btnLoading ? (
                                    <div className="p-5 m-auto text-center" data-aos="fade-up">
                                        {Modal === "Approve" ? (
                                            <>
                                                <h1 className="display-6 fw-bold">Approve</h1>
                                                <p>Do you want to approve this Invoice?</p>
                                            </>
                                        ) : Modal === "Decline" ? (
                                            <>
                                                <h1 className="display-6 fw-bold">Decline</h1>
                                                <p>Are you sure you want to decline this Invoice?</p>
                                            </>
                                        ) : Modal === "Revert" ? (
                                            <>
                                                <h1 className="display-6 fw-bold">Revert</h1>
                                                <p>Are you sure you want to revert this Invoice?</p>
                                            </>
                                        ) : (
                                            <></>
                                        )}
       
                                        {Modal === "Approve" ? (
                                            <button onClick={() => approveAction(Token)} className="mt-3 btn btn-success" type="button" style={{ height: "50px" }}>
                                                <svg className="bi bi-check-lg me-2" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
                                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"></path>
                                                </svg>
                                                Approve
                                            </button>
                                        ) : Modal === "Decline" ? (
                                            <button onClick={() =>{declineAction(Token) }} className="mt-3 btn btn-danger" type="button" style={{ height: "50px" }}>
                                                Decline
                                            </button>
                                        ) : Modal === "Revert" ? (
                                            <button onClick={() => {}} className="mt-3 btn btn-danger" type="button" style={{ height: "50px" }}>
                                                Revert
                                            </button>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                ) : (
                                    <div className="p-5 m-auto text-center" data-aos="fade-up">
                                        <Spinner />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Dialog>
    </div>
    </>);
}

export default Index;